import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalController } from '@ionic/angular';
import { GlobalService } from '../services/global/global.service';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss'],
})
export class ImageViewComponent  implements OnInit {

  @Input() imgSrc:any = "";
  safeImgSrc!: SafeResourceUrl;

  isLocalBlob:boolean = false;

  isPdf:boolean = false;

  constructor(
    private _modalController: ModalController,
    private _sanitizer: DomSanitizer,
    private _globalService: GlobalService
  ) { }

  ngOnInit() {  
    // Check if the URL is a Blob URL
    if (this.imgSrc.startsWith("blob:")) {
      this.isLocalBlob = true;
      fetch(this.imgSrc)
        .then(response => response.blob())
        .then(blob => {
          const mimeType = blob.type;
          const blobUrl = URL.createObjectURL(blob);
  
          if (mimeType === "application/pdf") {
            this.isPdf = true;
            this.safeImgSrc = this._sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
          } else if (mimeType.startsWith("image/")) {
            this.isPdf = false;
            this.imgSrc = blobUrl; // Directly assign for image display
          } else {
            console.error("Unsupported file type:", mimeType);
          }
        })
        .catch(error => console.error("Error fetching blob:", error));
    } else {
      // Handle normal URLs (as in your existing logic)
      const fileName = this.imgSrc.substring(
        this.imgSrc.lastIndexOf("/") + 1,
        this.imgSrc.indexOf("?") === -1 ? this.imgSrc.length : this.imgSrc.indexOf("?")
      );
  
      if (fileName.toLowerCase().endsWith(".pdf")) {
        this.isPdf = true;
        this.safeImgSrc = this._sanitizer.bypassSecurityTrustResourceUrl(this.imgSrc);
      } else {
        this.isPdf = false;
      }
    }
  }
  

  closeModal() {
    this._modalController.dismiss();
  }

  downloadFile(){
    this._globalService.downloadAndSaveFile(this.imgSrc, "Attachment")
  }

}
